import styled from 'styled-components';

import { colorBlack900, colorGrey400 } from 'styles';

export const RateValue = styled.span`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: ${colorBlack900};
  font-variant-numeric: lining-nums proportional-nums;
`;

export const RateValueSuffix = styled.span`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: ${colorGrey400};
  font-variant-numeric: lining-nums proportional-nums;
`;
